<template>

    <div class="py-5 px-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h1 class="font-bold text-xl">Complete!</h1>
                <h5>Your account has been successfully created.</h5>
            </div>
        </div>
         <div class="row mt-4 mb-2">
            <div class="col-md-12">
               <button class="w-full py-3 text-white bg-green-700 rounded-lg text-center focus:outline-none" v-on:click="goToDashboard">Continue to Dashboard</button>
            </div>
        </div>
    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'

	export default {
        name: 'Account',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App'
			}
        },
        methods: {
            goToDashboard() {
                this.$router.push({ name: 'DashboardRedirect' })
            },
        }
    }

</script>



<style scoped>

    .user-profile {
        width: 125px;
        height: 125px;
        margin: 0 auto;
        background-color: #000;
        border-radius: 50%
    }


</style>
